const r = "_wrapper_1e056_1", e = "_innerWrapper_1e056_10", p = "_stepHeadingWrapper_1e056_20", n = "_summary_1e056_26", a = "_summaryInnerWrapper_1e056_33", s = "_priceWrapper_1e056_42", t = "_brandColorTitle_1e056_51", _ = "_skeletonContainer_1e056_54", o = {
  wrapper: r,
  innerWrapper: e,
  stepHeadingWrapper: p,
  summary: n,
  summaryInnerWrapper: a,
  priceWrapper: s,
  brandColorTitle: t,
  skeletonContainer: _
};
export {
  t as brandColorTitle,
  o as default,
  e as innerWrapper,
  s as priceWrapper,
  _ as skeletonContainer,
  p as stepHeadingWrapper,
  n as summary,
  a as summaryInnerWrapper,
  r as wrapper
};
